'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

var _instagramProfileData = require('../instagram-profile-data');

var _instagramProfileData2 = _interopRequireDefault(_instagramProfileData);

var _facebookProfileDataLarge = require('../facebook-profile-data-large');

var _facebookProfileDataLarge2 = _interopRequireDefault(_facebookProfileDataLarge);

var _youtubeProfileDataLarge = require('../youtube-profile-data-large');

var _youtubeProfileDataLarge2 = _interopRequireDefault(_youtubeProfileDataLarge);

var _twitchData = require('../twitch-data');

var _twitchData2 = _interopRequireDefault(_twitchData);

var _tiktokProfileDataLarge = require('../tiktok-profile-data-large');

var _tiktokProfileDataLarge2 = _interopRequireDefault(_tiktokProfileDataLarge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MediaKitBody = function MediaKitBody(_ref) {
  var influencer = _ref.influencer,
      youtubeAPIDetails = _ref.youtubeAPIDetails,
      youtubeModalOpen = _ref.youtubeModalOpen,
      toggleYoutubeModalState = _ref.toggleYoutubeModalState,
      hasFullEngagementDataLink = _ref.hasFullEngagementDataLink,
      organisationId = _ref.organisationId,
      displayAuthorisedData = _ref.displayAuthorisedData;

  //
  if (!influencer) {
    return _react2.default.createElement(_semanticUiReact.Message, { content: 'No data to display', warning: true });
  }

  var countHistory = influencer.countHistory,
      facebookVerified = influencer.facebookVerified,
      facebook = influencer.facebook,
      instagram = influencer.instagram,
      youtube = influencer.youtube,
      facebookData = influencer.facebookData,
      statistics = influencer.statistics,
      influencerApiLink = influencer.influencerApiLink,
      twitch = influencer.twitch,
      twitchCount = influencer.twitchCount,
      tiktok = influencer.tiktok;


  var twitchProps = {
    twitchCount: twitchCount,
    twitch: twitch,
    countHistory: countHistory
  };

  var isMissingYoutubeAPILink = !_lodash2.default.isObject(influencerApiLink);
  return _react2.default.createElement(
    'div',
    null,
    youtube && _react2.default.createElement(_youtubeProfileDataLarge2.default, {
      displayAuthorisedData: displayAuthorisedData,
      hasFullEngagementDataLink: hasFullEngagementDataLink,
      influencer: influencer,
      apiInfluencer: youtubeAPIDetails,
      missingAPILink: isMissingYoutubeAPILink,
      youtubeDemographicsModalOpen: youtubeModalOpen,
      toggleYoutubeDemographicsModalState: toggleYoutubeModalState
    }),
    instagram && _react2.default.createElement(_instagramProfileData2.default, {
      influencer: influencer,
      stats: statistics,
      data: instagram,
      organisationId: organisationId,
      displayAuthorisedData: displayAuthorisedData
    }),
    facebook && _react2.default.createElement(_facebookProfileDataLarge2.default, (0, _extends3.default)({
      displayAuthorisedData: displayAuthorisedData
    }, facebookData, {
      influencer: influencer,
      handle: facebook,
      countHistory: countHistory,
      facebookVerified: facebookVerified
    })),
    twitch && _react2.default.createElement(_twitchData2.default, { influencer: twitchProps }),
    tiktok && _react2.default.createElement(_tiktokProfileDataLarge2.default, {
      influencer: influencer,
      countHistory: countHistory
    })
  );
};

MediaKitBody.defaultProps = {
  displayAuthorisedData: false
};

exports.default = MediaKitBody;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/media-kit-body/index.js
 ** module id = 2599
 ** module chunks = 0
 **/